import { mergeMessages } from '../translate';
import { commonEn } from './common';
import { consoleCounterEn } from './console-counter';
import { consoleDeskEn } from './console-desk';
import { consoleInsightsEn } from './console-insights';
import { consoleSetupEn } from './console-setup';
import { consoleShellEn } from './console-shell';
import { prototypeEn } from './en';
import { webEn } from './web';
import { webBookingEn } from './web-booking';

/** Every English string the console can show. */
export const consoleMessages = mergeMessages(
  prototypeEn,
  commonEn,
  consoleShellEn,
  consoleDeskEn,
  consoleCounterEn,
  consoleSetupEn,
  consoleInsightsEn,
);

/** Every English string the public site can show (server side; client islands get subsets). */
export const webMessages = mergeMessages(prototypeEn, commonEn, webEn, webBookingEn);
